import { UseQueryDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { ImportTableDefinitionRepository } from '@front/repository/Api/ImportTableDefinition';
import { useQuery } from '@tanstack/react-query';
import { AuthDomain } from 'auth-lib-front';
import { DomainV2 } from 'troppus-common/domain';
import { importTableDefinitionQueryKeys } from './queryKeys';

import Project = AuthDomain.Object.Project;
import ImportTableDefinition = DomainV2.Import.ImportTableDefinition;

const repository = new ImportTableDefinitionRepository();

type Options = {
  enabled?: boolean;
  sourceSystemId?: ImportTableDefinition['sourceSystemId'];
};

export const _list = (projectId: Project.Id, options?: Options) => {
  return useQuery({
    queryKey: importTableDefinitionQueryKeys.list(projectId, options?.sourceSystemId),
    queryFn: async ({ signal }) => {
      return repository.list(
        { projectId, sourceSystemId: options?.sourceSystemId },
        { signal: signalToTimeout(DEFAULT_TIMEOUT.QUERY, signal) },
      );
    },
    enabled: options?.enabled ?? true,
    ...UseQueryDefaultOptions,
  });
};
